export const WORKSPACE_PICKER_PATH = "/?select=1";
